module.exports = __webpack_public_path__ + "static/hotblack-jingle-79ce4521ccca9d64ae6e365c6b9d924f.mp4";